export default (str, maxLength) => {

  if (!str)
    return ""

  str = str.trim()

  if (str.length > maxLength)
    str = str.substring(0, (maxLength - 3)) + "..."

  return str
}